import { Title, TitleSection, Wrapper } from "../Properties/Details/styles";
import AmenitiesIcon from "./AmenitiesIcon";
import Inventory from "./Inventory";
import RulesCategories from "./RulesCategories";
import UtilityCategory from "./UtilityCategory";

export default function PropertyResource() {
  return (
    <Wrapper>
      <TitleSection>
        <Title> Property Resource Management </Title>
      </TitleSection>
      <AmenitiesIcon />
      <Inventory />
      <RulesCategories />
      <UtilityCategory />
    </Wrapper>
  );
}
